import { Default, Detail,  List, Create } from "./views";
import { ApplyAction } from "./wizards";



const Module = {
    name: "zohohistoricalorders",
    defaultRoutePath: "/zoho/historicalorder",
    menuItemScope: "sync",
    menuItemName: "zohohistoricalorders",

    routes: [
        {
            path: "/zoho/historicalorder",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "applyAction",
            Component: ApplyAction,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        // {
        //     path: "create",
        //     Component: Create,
        // },
    ],
    
}

export default Module;
